/* ============================================
   CUSTOM HEADER - JavaScript
   文件路径: assets/custom-header.js
============================================ */

(function () {
  'use strict';

  const announcementBar = document.getElementById('custom-announcement-bar');
  const stickyWrapper   = document.getElementById('custom-header-sticky');
  const searchDropdown  = document.getElementById('custom-search-dropdown');

  // ── 核心位置计算 ─────────────────────────────
  function updatePositions() {
    const annH = (announcementBar && !announcementBar.classList.contains('is-hidden'))
      ? announcementBar.offsetHeight : 0;

    if (stickyWrapper) stickyWrapper.style.top = annH + 'px';

    requestAnimationFrame(function () {
      const navH   = stickyWrapper ? stickyWrapper.offsetHeight : 0;
      const totalH = annH + navH;

      document.body.style.paddingTop = totalH + 'px';

      document.querySelectorAll('.custom-mega-menu').forEach(function (m) {
        m.style.top = totalH + 'px';
      });

      if (searchDropdown) searchDropdown.style.top = totalH + 'px';
    });
  }

  updatePositions();
  window.addEventListener('resize', updatePositions, { passive: true });

  if (window.ResizeObserver) {
    const ro = new ResizeObserver(updatePositions);
    if (announcementBar) ro.observe(announcementBar);
    if (stickyWrapper)   ro.observe(stickyWrapper);
  }

  // ── 公告栏 ───────────────────────────────────
  const announcementClose = document.querySelector('.custom-announcement-bar__close');

  if (announcementBar && announcementClose) {
    if (sessionStorage.getItem('announcementClosed') === '1') {
      announcementBar.classList.add('is-hidden');
      updatePositions();
    }

    announcementClose.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      announcementBar.classList.add('is-hidden');
      sessionStorage.setItem('announcementClosed', '1');
      updatePositions();
    });
  }

  // ── 搜索下拉 ─────────────────────────────────
  const searchBtn   = document.querySelector('.custom-header__search-btn');
  const searchClose = document.getElementById('custom-search-close');
  const searchInput = searchDropdown && searchDropdown.querySelector('.custom-search-dropdown__input');

  function openSearch() {
    if (!searchDropdown) return;
    updatePositions();
    searchDropdown.classList.add('is-open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        searchDropdown.classList.add('is-visible');
      });
    });
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 100);
  }

  function closeSearch() {
    if (!searchDropdown) return;
    searchDropdown.classList.remove('is-visible');
    setTimeout(function () {
      if (!searchDropdown.classList.contains('is-visible')) {
        searchDropdown.classList.remove('is-open');
      }
    }, 200);
  }

  if (searchBtn)   searchBtn.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSearch(); }
  });

  document.addEventListener('click', function (e) {
    if (!searchDropdown || !searchDropdown.classList.contains('is-open')) return;
    if (!searchDropdown.contains(e.target) && searchBtn && !searchBtn.contains(e.target)) {
      closeSearch();
    }
  });

  // ── 购物车抽屉 ───────────────────────────────
  const cartBtn      = document.querySelector('.custom-header__cart-btn');
  const cartDrawer   = document.getElementById('custom-cart-drawer');
  const cartOverlay  = document.getElementById('custom-cart-overlay');
  const cartClose    = document.getElementById('custom-cart-close');
  const cartBody     = document.getElementById('custom-cart-body');
  const cartFooter   = document.getElementById('custom-cart-footer');
  const cartSubtotal = document.getElementById('custom-cart-subtotal');

  function formatMoney(cents) {
    try {
      return (cents / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function openCartDrawer() {
    if (cartDrawer)  cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderCart();
  }

  function closeCartDrawer() {
    if (cartDrawer)  cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartBtn)     cartBtn.addEventListener('click', openCartDrawer);
  if (cartClose)   cartClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  function renderCart() {
    if (!cartBody) return;
    cartBody.innerHTML = '<div style="padding:40px;text-align:center;color:#aaa;font-size:14px;">Loading...</div>';

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCountBadge(cart.item_count);

        if (cart.item_count === 0) {
          cartBody.innerHTML = [
            '<div class="custom-cart-drawer__empty">',
            '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="48" height="48">',
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4zM3 6h18M16 10a4 4 0 0 1-8 0"/>',
            '</svg>',
            '<div class="custom-cart-drawer__empty-title">Your cart is empty</div>',
            '<div class="custom-cart-drawer__empty-text">Don\'t let great meals wait!<br>Complete your cart with our premium cookware.</div>',
            '<a href="/collections/all" class="custom-cart-drawer__empty-btn">Shop Now</a>',
            '</div>'
          ].join('');
          if (cartFooter) cartFooter.style.display = 'none';
          return;
        }

        var html = '<div class="custom-cart-drawer__items">';
        cart.items.forEach(function (item) {
          var imgSrc       = item.image || '';
          var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
          var originalPrice = (item.original_price !== item.final_price)
            ? '<span class="custom-cart-item__price--original">' + formatMoney(item.original_price) + '</span>' : '';

          html += [
            '<div class="custom-cart-item" data-key="' + item.key + '">',
            '  <div class="custom-cart-item__img-wrap">',
            imgSrc ? '    <img class="custom-cart-item__img" src="' + imgSrc + '" alt="' + item.product_title + '" loading="lazy">' : '',
            '  </div>',
            '  <div class="custom-cart-item__info">',
            '    <a class="custom-cart-item__title" href="' + item.url + '">' + item.product_title + '</a>',
            variantTitle ? '    <div class="custom-cart-item__variant">' + variantTitle + '</div>' : '',
            '    <div class="custom-cart-item__bottom">',
            '      <div class="custom-cart-item__qty">',
            '        <button class="custom-cart-item__qty-btn" data-action="decrease"' + (item.quantity <= 1 ? ' disabled' : '') + '>&#8722;</button>',
            '        <span class="custom-cart-item__qty-num">' + item.quantity + '</span>',
            '        <button class="custom-cart-item__qty-btn" data-action="increase">+</button>',
            '      </div>',
            '      <div>' + originalPrice + '<span class="custom-cart-item__price">' + formatMoney(item.final_line_price) + '</span></div>',
            '    </div>',
            '    <button class="custom-cart-item__remove" data-action="remove">',
            '      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="12" height="12">',
            '        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>',
            '      </svg>',
            '      Remove',
            '    </button>',
            '  </div>',
            '</div>'
          ].join('');
        });
        html += '</div>';

        cartBody.innerHTML = html;

        if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
        if (cartFooter)   cartFooter.style.display = 'block';

        cartBody.querySelectorAll('.custom-cart-item').forEach(function (itemEl) {
          var key = itemEl.getAttribute('data-key');

          var incBtn = itemEl.querySelector('[data-action="increase"]');
          var decBtn = itemEl.querySelector('[data-action="decrease"]');
          var remBtn = itemEl.querySelector('[data-action="remove"]');

          if (incBtn) incBtn.addEventListener('click', function () {
            var qty = parseInt(itemEl.querySelector('.custom-cart-item__qty-num').textContent, 10) + 1;
            updateCartItem(key, qty, itemEl);
          });

          if (decBtn) decBtn.addEventListener('click', function () {
            var qty = parseInt(itemEl.querySelector('.custom-cart-item__qty-num').textContent, 10) - 1;
            if (qty < 1) return;
            updateCartItem(key, qty, itemEl);
          });

          if (remBtn) remBtn.addEventListener('click', function () {
            updateCartItem(key, 0, itemEl);
          });
        });
      })
      .catch(function () {
        if (cartBody) cartBody.innerHTML = '<div style="padding:40px;text-align:center;color:#e00;">Failed to load cart. Please refresh.</div>';
      });
  }

  function updateCartItem(key, quantity, itemEl) {
    if (itemEl) itemEl.classList.add('is-loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { renderCart(); })
      .catch(function () { if (itemEl) itemEl.classList.remove('is-loading'); });
  }

  function updateCartCountBadge(count) {
    document.querySelectorAll('.custom-cart-count').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });
  }

  document.addEventListener('cart:updated', renderCart);

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCartCountBadge(cart.item_count); })
    .catch(function () {});

  // ── Mega Menu ────────────────────────────────
  var navItems      = document.querySelectorAll('.custom-nav__item[data-has-dropdown="true"]');
  var activeNavItem = null;
  var closeTimer    = null;

  function openMenu(navItem) {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (activeNavItem && activeNavItem !== navItem) closeMenuImmediate(activeNavItem);

    var megaMenu = navItem.querySelector('.custom-mega-menu');
    if (!megaMenu) return;

    updatePositions();
    navItem.classList.add('is-active');
    megaMenu.classList.add('is-open');
    activeNavItem = navItem;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        megaMenu.classList.add('is-visible');
      });
    });

    var firstItem = megaMenu.querySelector('.custom-mega-menu__list-item');
    if (firstItem) setActiveMenuItem(megaMenu, firstItem, false);
  }

  function closeMenu(navItem) {
    closeTimer = setTimeout(function () { closeMenuImmediate(navItem); }, 150);
  }

  function closeMenuImmediate(navItem) {
    var megaMenu = navItem.querySelector('.custom-mega-menu');
    if (!megaMenu) return;
    navItem.classList.remove('is-active');
    megaMenu.classList.remove('is-visible');
    setTimeout(function () {
      if (!megaMenu.classList.contains('is-visible')) megaMenu.classList.remove('is-open');
    }, 200);
    if (activeNavItem === navItem) activeNavItem = null;
  }

  function setActiveMenuItem(megaMenu, listItem, animate) {
    megaMenu.querySelectorAll('.custom-mega-menu__list-item').forEach(function (i) {
      i.classList.remove('is-active');
    });
    listItem.classList.add('is-active');

    var img   = listItem.getAttribute('data-img');
    var desc  = listItem.getAttribute('data-desc');
    var label = listItem.getAttribute('data-label');

    var preview      = megaMenu.querySelector('.custom-mega-menu__preview');
    var previewImg   = megaMenu.querySelector('.custom-mega-menu__preview-image');
    var previewLabel = megaMenu.querySelector('.custom-mega-menu__preview-label');
    var previewDesc  = megaMenu.querySelector('.custom-mega-menu__preview-desc');

    if (!preview) return;

    function applyContent() {
      if (previewImg) {
        if (img) {
          previewImg.src = img;
          previewImg.alt = label || '';
          previewImg.classList.remove('is-hidden');
        } else {
          previewImg.classList.add('is-hidden');
        }
      }
      if (previewLabel) previewLabel.textContent = label || '';
      if (previewDesc)  previewDesc.textContent  = desc  || '';
    }

    if (animate === false) {
      applyContent();
    } else {
      preview.classList.add('is-transitioning');
      setTimeout(function () {
        applyContent();
        preview.classList.remove('is-transitioning');
      }, 150);
    }
  }

  navItems.forEach(function (navItem) {
    var megaMenu = navItem.querySelector('.custom-mega-menu');
    if (!megaMenu) return;

    navItem.addEventListener('mouseenter', function () { openMenu(navItem); });
    navItem.addEventListener('mouseleave', function () { closeMenu(navItem); });

    megaMenu.addEventListener('mouseenter', function () {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    });
    megaMenu.addEventListener('mouseleave', function () { closeMenu(navItem); });

    megaMenu.querySelectorAll('.custom-mega-menu__list-item').forEach(function (listItem) {
      listItem.addEventListener('mouseenter', function () {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        setActiveMenuItem(megaMenu, listItem, true);
      });
    });
  });

  // ── 语言切换下拉开关 ─────────────────────────
  var localeBtn      = document.querySelector('.custom-header__locale');
  var localeDropdown = document.querySelector('.custom-header__locale-dropdown');

  if (localeBtn && localeDropdown) {
    localeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = localeDropdown.classList.toggle('is-open');
      localeBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    document.addEventListener('click', function () {
      if (localeDropdown) {
        localeDropdown.classList.remove('is-open');
        if (localeBtn) localeBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // ── 语言/货币切换提交（桌面 + 移动端通用）── ★新增★
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-locale][data-form]');
    if (!btn) return;

    var formId  = btn.dataset.form;
    var locale  = btn.dataset.locale;
    var country = btn.dataset.country;
    var form    = document.getElementById(formId);
    if (!form) return;

    form.querySelector('[name="locale_code"]').value  = locale;
    form.querySelector('[name="country_code"]').value = country;

    // 确保 return_to 存在，切换后返回当前页
    var returnTo = form.querySelector('[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.appendChild(returnTo);
    }
    returnTo.value = window.location.pathname;

    form.submit();
  });

  // ── 移动端菜单 ──────────────────────────────
  var mobileMenuBtn = document.querySelector('.custom-header__mobile-menu-btn');
  var mobileMenu    = document.querySelector('.custom-mobile-menu');
  var mobileOverlay = document.querySelector('.custom-mobile-menu__overlay');
  var mobileClose   = document.querySelector('.custom-mobile-menu__close');

  function openMobileMenu() {
    if (mobileMenu)    mobileMenu.classList.add('is-open');
    if (mobileOverlay) mobileOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (mobileMenu)    mobileMenu.classList.remove('is-open');
    if (mobileOverlay) mobileOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    updatePositions();
  }

  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', openMobileMenu);
  if (mobileClose)   mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  document.querySelectorAll('.custom-mobile-nav__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item  = btn.closest('.custom-mobile-nav__item');
      var sub   = item && item.querySelector('.custom-mobile-nav__sub');
      var arrow = btn.querySelector('.custom-nav__arrow');
      if (sub) {
        sub.classList.toggle('is-open');
        if (arrow) arrow.style.transform = sub.classList.contains('is-open') ? 'rotate(180deg)' : '';
      }
    });
  });

})();